import './js/addFavoriteCocktail';
import './js/header/header-mobile';
import './js/header/headerSearchByName';

import { renderFavoriteIngredientMarkup } from './js/createFavoritsIngredientPage';

renderFavoriteIngredientMarkup();
